import roadmap from "../../../../public/roadmap";
import ItemMap from './itemMap';
import AppData from "../../../../public/const/app_data";



const { ccclass, property } = cc._decorator;

// 洗牌中:กำลังล้างไพ่  准备中:กำลังเตรียม   发牌中:กำลังแจกไพ่   下注中:กำลังเติมพัน  开牌中:กำลังเปิด        派奖中: กำลังแจกรางวัล  "限额: จำกัดชิป    体验房 T ห้องประสบการ     初级房 C ห้องระดับต้น                  中级房 Z ห้องระดับกลาง    高级房 G ห้องระดับสูง

@ccclass
export default class GoldRoomItem extends cc.Component {


    @property(roadmap)
    myRoadmap: roadmap = null // 路图
    @property(ItemMap)
    itemRoadmap: ItemMap = null // 鱼虾蟹 骰宝路图
    @property(cc.Label)
    roomName: cc.Label = null // 场次编号
    @property(cc.Label)
    state: cc.Label = null // 状态
    @property(cc.Label)
    countDownLab: cc.Label = null // 倒计时

    // @property(cc.Label)
    // limit: cc.Label = null // 限额
    public data = null
    /*
        BANKER_UP = 0,    -- 上庄
        STARTING = 1,      -- 开始
        SHUFFLING = 2,    -- 洗牌
        READY = 3,      -- 准备
        DEAL = 4,      -- 发牌
        BETTING = 5,      -- 下注
        TURN = 6,      -- 开牌
        SETTLE = 7,      -- 派奖
        BETTING_END = 8,    -- 下注等待
        RESET = 100,    -- 准备开始下一局
    */
    // stateStr =       ["","洗牌中:","准备中:","发牌中:","下注中:","开牌中:","派奖中:"]
    //readonly stateStr = ["", "ล้างไพ่", "เตรียม", "แจกไพ่", "เดิมพัน", "กำลังเปิด", "แจกรางวัล"]

    readonly stateStr = { 2:"ล้างไพ่",3:"เตรียม",4:"แจกไพ่",5:"เดิมพัน",6:"กำลังเปิด",7:"แจกรางวัล" };

    // stateLabelColor = [new cc.Color(254, 215, 143, 255), new cc.Color(254, 215, 143, 255), new cc.Color(52, 217, 90, 255), new cc.Color(254, 215, 143, 255), 
    //                     new cc.Color(254, 215, 143, 255), new cc.Color(254, 215, 143, 255), new cc.Color(254, 91, 70, 255)]
    countDownFn = null
    isFirst = true;
    onLoad() {
        this.isFirst = true;        
    }

    onDisable(){

        this.isFirst = true;
    }
    
    setData(data) {
        this.data = data
        //cc.log("setData:",data);
        if(data.apiData){
            //cc.log("显示GoldRoomItem 中的数据:",data);
            if(data.goldType && data.roomIx)
            {
                this.roomName.string = this.showRoomIx(data.goldType, data.roomIx)
            }
            this.state.string = ""
            if(data.playRule){
                //cc.log("data.playRule 中的数据:",rule);
                //this.limit.string = "จำกัดชิป: " + Util.toThousands(rule. MinbetLimit) +"-"+ Util.toThousands(rule. MaxbetLimit)
                // this.minLimit.string = Util.toThousands(rule. MinbetLimit);
                // this.maxLimit.string = Util.toThousands(rule. MaxbetLimit);
            }
        }
        else{
            data.history = data.history ? data.history : []
            //cc.log("选场刷新龙虎路图 data:",data);
            if (this.myRoadmap) {
                this.myRoadmap.onRefreshDisplay(this.disposeHistoryData(data.history), 1)
            }
            this.roomName.string = this.showRoomIx(data.roomType, data.roomIx)
    
            this.updateCD(data);
        }
    }
    //鱼虾蟹 骰宝 路图
    setItemMapData(data) {
        cc.log("刷新鱼虾蟹新路途data:",data.roomId,data.apiData);
        this.data = data
        if(data.goldType && data.roomIx)
        {
            this.roomName.string = this.showRoomIx(data.goldType, data.roomIx)
        }
        this.state.string = "";

        data.history = data.history ? data.history : []
        if (this.itemRoadmap) {
            cc.log("鱼虾蟹路图数据:",this.isFirst);
            if (this.isFirst) {
                this.itemRoadmap.LoadItem();
                this.isFirst = false;
            }
            this.itemRoadmap.updateShow(this.disposeHistoryData(data.history));
        }
        //cc.log("data.roomType:", data.roomType, data.roomIx);
        this.roomName.string = this.showRoomIx(data.roomType, data.roomIx)

        this.updateCD(data);
    }


    updateCD(data){

        let self = this;
        if (data.curState) {

            let countDown = data.curTime

            this.state.string = this.stateStr[data.curState];
            this.countDownLab.string = countDown + "s";
            if (this.countDownFn) {
                this.unschedule(this.countDownFn)
            }
            this.countDownFn = function () {
                if (countDown > 1) {                    
                    self.countDownLab.string = --countDown + "s"
                }else{
                    this.unschedule(this.countDownFn)
                    this.countDownFn = null
                }
            }
            this.schedule(this.countDownFn, 1, countDown, 0)

        } else {
            this.state.string = ""
            this.countDownLab.string = ""

            if (this.countDownFn) {
                this.unschedule(this.countDownFn)
                this.countDownFn = null
            }
        }
    }

    // roomSting = ["芒果场"."","初级房 C","中级房 Z","高级房 G"]
    //屏蔽芒果场
    roomSting = { 10:"ห้องMANGO" ,1:"ห้องระดับต้น", 2:"ห้องระดับกลาง",3:"ห้องระดับสูง",4:"ห้องชั้นเซียน",5:"ห้องซั้นเทพ",};
    //初级场: ห้องระดับต้น 中级场: ห้องระดับกลาง  高级场:ห้องระดับสูง  至尊场: ห้องชั้นเซียน 王者场:ห้องซั้นเทพ 芒果场:ห้องMANGO
    showRoomIx(roomType, roomIx) {
        let t = null
        if (roomIx < 10) {
            t = "00" + roomIx
        } else if (roomIx < 100) {
            t = "0" + roomIx
        } else {
            t = roomIx
        }
        return this.roomSting[roomType] + t
        //return this.roomSting[this.returnToggleNumber(roomType)] + t
    }


    showNumber(num) {
        let showNum = ""
        if (num > 9999) {
            showNum = num / 10000 + "0k"
        } else if (num > 999) {
            showNum = num / 1000 + "k"
        } else {
            showNum = num
        }
        return showNum
    }

    disposeHistoryData(hist) : any{   
        //百家乐不需要转     
        if (AppData.gameName == "TM_BJL") {
            
            return hist;
        }

        if (hist == null) {
            return []
        }
        let ret = []
        for (const value of hist) {
            ret[ret.length] = value.result
        }
        //cc.log("ret:",ret);
        return ret
    }
    //转化 10 芒果币场  1-4 初级 中级 高级 至尊
    returnToggleNumber(roomType: any) {
        var temp = Number(roomType);
        var index = 0;
        if (temp == 10) {
            index = 0;
        }
        else {
            index = temp;
        }
        return index;
    }

}